import _regeneratorRuntime from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
/**
 * @file Created on Thu Aug 09 2018
 * @author VBr
 */


import { action, observable, runInAction } from 'mobx';
import { local as localStorage } from '../../storage';
import { BaseStore } from '../BaseStore';
import { StoreName } from '../StoreName';
import { LoadingState } from '../../api/LoadingState';
import { DictionaryLayer } from '../../transportLayers/dictionary/DictionaryLayer';
export var DictionaryStore =
/*#__PURE__*/
function (_BaseStore) {
  _inherits(DictionaryStore, _BaseStore);

  function DictionaryStore() {
    var _this;

    _classCallCheck(this, DictionaryStore);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(DictionaryStore).apply(this, arguments));
    _this.name = StoreName.Dictionary;
    _this.dictionaryLayer = new DictionaryLayer(); // Change this state when all data are ready (or fetching failed).

    _this.loadingState = LoadingState.Pending;
    /** Active language */

    _this.language = 'en';
    /** Dictionary object */

    _this.localizations = {};
    /** Edits in local storage */

    _this.edits = JSON.parse(localStorage.get('localization')) || {};
    /** Is display of translation keys active */

    _this.showKeys = false;
    /** Is edit mode active */

    _this.editMode = false;
    return _this;
  }
  /**
   * Function that updates current displayed language
   * @param languageId locale code
   */


  _createClass(DictionaryStore, [{
    key: "changeLanguage",
    value: function changeLanguage(languageId) {
      var _this2 = this;

      if (this.localizations.hasOwnProperty(languageId)) {
        this.language = languageId;
      } else {
        this.initLanguage(languageId).then(function (_) {
          return _this2.language = languageId;
        });
      }
    }
    /**
     * Function that switch display of localization keys
     */

  }, {
    key: "toggleKeys",
    value: function toggleKeys() {
      this.showKeys = !this.showKeys;
    }
    /**
     * Function that switch edit mode
     */

  }, {
    key: "toggleEdit",
    value: function toggleEdit() {
      this.editMode = !this.editMode;
    }
    /**
     * Function that store new localization record to local storage in edit mode
     * @param language locale code
     * @param key localization key
     * @param value translation
     */

  }, {
    key: "updateLocalization",
    value: function updateLocalization(language, key, value) {
      var stored = JSON.parse(localStorage.get('localization')) || {};

      if (!stored[language]) {
        stored[language] = {};
      }

      stored[language][key] = value;
      localStorage.add('localization', JSON.stringify(stored));
      this.edits = stored;
    }
  }, {
    key: "initLanguage",
    value: function initLanguage() {
      var languageId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.language;
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee() {
        var _this3 = this;

        var result;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.loadingState = LoadingState.Pending;
                _context.next = 3;
                return this.dictionaryLayer.findOne(languageId);

              case 3:
                result = _context.sent;
                runInAction(function () {
                  if (result.localisation) {
                    _this3.localizations[languageId] = result.localisation;
                  }

                  _this3.loadingState = LoadingState.Success;
                });

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    }
  }]);

  return DictionaryStore;
}(BaseStore);

__decorate([observable, __metadata("design:type", Number)], DictionaryStore.prototype, "loadingState", void 0);

__decorate([observable, __metadata("design:type", String)], DictionaryStore.prototype, "language", void 0);

__decorate([observable, __metadata("design:type", Object)], DictionaryStore.prototype, "localizations", void 0);

__decorate([observable, __metadata("design:type", Object)], DictionaryStore.prototype, "edits", void 0);

__decorate([observable, __metadata("design:type", Boolean)], DictionaryStore.prototype, "showKeys", void 0);

__decorate([observable, __metadata("design:type", Boolean)], DictionaryStore.prototype, "editMode", void 0);

__decorate([action.bound, __metadata("design:type", Function), __metadata("design:paramtypes", [String]), __metadata("design:returntype", void 0)], DictionaryStore.prototype, "changeLanguage", null);

__decorate([action.bound, __metadata("design:type", Function), __metadata("design:paramtypes", []), __metadata("design:returntype", void 0)], DictionaryStore.prototype, "toggleKeys", null);

__decorate([action.bound, __metadata("design:type", Function), __metadata("design:paramtypes", []), __metadata("design:returntype", void 0)], DictionaryStore.prototype, "toggleEdit", null);

__decorate([action.bound, __metadata("design:type", Function), __metadata("design:paramtypes", [String, String, String]), __metadata("design:returntype", void 0)], DictionaryStore.prototype, "updateLocalization", null);

__decorate([action.bound, __metadata("design:type", Function), __metadata("design:paramtypes", [String]), __metadata("design:returntype", Promise)], DictionaryStore.prototype, "initLanguage", null);